export default __webpack_public_path__ + "static/fog-1-f941d9347efb2a3e7d1d8207b0450d49.png";